import { useMemo } from 'react';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { onErrorDefault } from '@occc-app/dataAccessLayer/utils';
import { useScanDataWeekEndingOverviewQuery } from '@occc/graphql';
import { DateTimeFormat, formatDateTime } from '@occc-app/lib/date';

export const useScanDataWeekEndingOverview = (weekEndingDate: Date) => {
  const weekEndingDateEquals = useMemo(
    () => formatDateTime(weekEndingDate, DateTimeFormat.DateDashed),
    [weekEndingDate],
  );

  return useScanDataWeekEndingOverviewQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    onError: onErrorDefault,
    variables: {
      filter: {
        weekEndingDateEquals,
      },
    },
  });
};
